import Papa from 'papaparse';

export const downloadCsvBlob = (data: any, filename: string) => {
  const csv = Papa.unparse(data, { quotes: false, delimiter: ',' });
  const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
